import React from "react";
import Error403Page from "../ErrorPage/Error403Page";
import useRequiredPermission from "../../../../utility/hooks/useRequiredPermission";

interface SecuredRouteProps {
  children: React.ReactNode;
  requiredPermission?: string | string[];
}

const SecuredRoute: React.FC<SecuredRouteProps> = ({
  children,
  requiredPermission,
}) => {
  const permissionArray = Array.isArray(requiredPermission)
    ? requiredPermission
    : requiredPermission
    ? [requiredPermission]
    : [];

  const hasRequiredPermission = useRequiredPermission(permissionArray);

  return hasRequiredPermission ? <>{children}</> : <Error403Page />;
};

export default SecuredRoute;
